export const FRONTEND_STATE_ZINDEX_ENTITIES_WITH_ORDER_ENSURED = 'FRONTEND_STATE_ZINDEX_ENTITIES_WITH_ORDER_ENSURED';
export const FRONTEND_STATE_ZINDEX_ENTITIES_RELEASED = 'FRONTEND_STATE_ZINDEX_ENTITIES_RELEASED';
